import { faPipe } from '@fortawesome/pro-solid-svg-icons';
import type { ReactNode } from 'react';

import { Sport } from '#src/__generated__/globalTypes.ts';
import { MLBLogo } from '#src/atoms/icons/MLBLogo.tsx';
import { NBALogo } from '#src/atoms/icons/NBALogo.tsx';
import { SorareLogo } from '#src/atoms/icons/SorareLogo/index.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { FootballLogo } from '#src/routing/MultiSportAppBar/Sport/Football/index.tsx';

export const sportLogos: Record<Sport, ReactNode> = {
  [Sport.FOOTBALL]: <FootballLogo />,
  [Sport.NBA]: <NBALogo />,
  [Sport.BASEBALL]: <MLBLogo />,
};

type Props = {
  sport: Sport;
  withSorareLogo?: boolean;
};

export const SportLogo = ({ sport, withSorareLogo = true }: Props) => {
  return (
    <>
      {!!withSorareLogo && (
        <>
          <SorareLogo />
          {[Sport.BASEBALL, Sport.NBA].includesValue(sport) && (
            <FontAwesomeIcon icon={faPipe} color="var(--c-white)" />
          )}
        </>
      )}
      {sportLogos[sport]}
    </>
  );
};
